import Animation from './animation'
import AreaTransformer from '../../line-area/area/transformers/area-bar-transformer'
import * as d3 from 'd3-selection'
import PieTransformer from '../transformers/pie-bar-transformer'
import * as ease from 'd3-ease'

/*
 * This animation is used to take a single serie that was previously
 * an area and turn it into a pie.
 */
class FromAreaAnimation extends Animation {

  constructor (options) {
    super(options)
    this.twoPart = true
    this.ripple = true
  }

  match (serie) {
    let prev = this.previous.allSerieTypes[serie.id]
    return prev && prev.type === 'area'
  }

  animate (serie, entering, selection, merged, exiting) {
    let previousSerie = this.previous.allSerieTypes[serie.id].serie
      , self = this
      , areaStyles = {
          stroke: previousSerie.selectAll('path.line.data-line').style('stroke'),
          lineStrokeWidth: previousSerie.selectAll('path.line.data-line').style('stroke-width'),
          areaStrokeWidth: previousSerie.selectAll('path.area').style('stroke-width'),
          fill: previousSerie.selectAll('path.area').style('fill'),
          opacity: previousSerie.selectAll('path.area').style('opacity')
        }
      , areaTransformer = new AreaTransformer({
          serie: previousSerie,
          previous: this.previous,
          scalers: this.previous.scalers,
          yScale: this.previous.yScale,
          splitWidth: this.serieScale.bandwidth(),
          areaScale: this.previous.scalers,
          splitScale: d => {
            return this.previous.scalers.x.groupScale(d.rangeId) + this.serieScale(serie._columnIdx)
          },
          styles: {
            area: areaStyles,
            bar: areaStyles
          }
        })

    let splits = areaTransformer.insert(0)

    // Remove the previous serie now that it's transforming into subpaths
    this.previous.allSerieTypes[serie.id].serie.remove()

    splits.transition()
          .delay(d => this.timing.delay(d._data))
          .duration(this.timing.duration)
          .ease(ease.easeCubicIn)
          .tween('bars', function (d) {
            return t => {
              areaTransformer.transform(t, this)
            }
          })
          .transition()
          .tween('pies', function (d) {
            let slice = entering.filter(enter => {
              return enter.rangeId == d._data.rangeId
            })
            let that = this

            slice.style('opacity', 1)
                 .transition() // New element, so we need a new transition
                 .duration(self.timing.duration)
                 .ease(ease.easeCubicOut)
                 .tween('arc', function (d) {
                    let transformer = new PieTransformer({
                      d,
                      styles: self.styles,
                      x: self.previous.scalers.x.groupScale(d.rangeId) + self.serieScale(serie._columnIdx),
                      y: self.previous.yScale(Math.max(0, d.slice.data._range[1])),
                      width: self.serieScale.bandwidth(),
                      height: Math.abs(self.previous.yScale(d.slice.data._range[0]) - self.previous.yScale(d.slice.data._range[1])),
                      path: d3.select(`#${d.pathUid.id}`),
                      use: d3.select(this)
                    })

                    d3.select(that).remove()

                    return t => {
                      transformer.transform(t)
                    }
                  })
                 .on('end', function () {
                    d3.select(this)
                      .attr('transform', d => {
                        return `translate(${d.dimensions.x + d.dimensions.width / 2}, ${d.dimensions.y + d.dimensions.height / 2})`
                      })
                 })
          })
  }

}

export default FromAreaAnimation
